<template>
<div class="socials">
      <a
        class="social-button social-button--facebook quiz-button"
        aria-label="Delen op Facebook"
        :href="getShareLink('facebook')"
        target="_blank"
      >
      </a>
      <a
        class="social-button social-button--twitter quiz-button"
        aria-label="Delen op Twitter"
        :href="getShareLink('twitter')"
        target="_blank"
      >
      </a>
      <a
        class="social-button social-button--linkedin quiz-button"
        aria-label="Delen op LinkedIn"
        :href="getShareLink('linkedin')"
        target="_blank"
      >
      </a>
      <a
        class="social-button social-button--whatsapp quiz-button"
        aria-label="Delen op whatsapp"
        :href="getShareLink('whatsapp')"
        target="_blank"
      >
      </a>
    </div>
</template>

<script>
export default {
  name: "Socials",
  methods: {
    getShareLink(platform) {
      let host = `https://${window.location.host}`;
      switch (platform) {
        case 'facebook':
					return `https://www.facebook.com/sharer/sharer.php?u=${host}`;
				case 'twitter':
					return `https://twitter.com/intent/tweet?url=${host}`;
				case 'linkedin':
					return `https://www.linkedin.com/sharing/share-offsite?url=${host}`;
				case 'whatsapp': 
          return `whatsapp://send?text=${host}`;
      }
    }
  },
};
</script>

<style scoped>


.socials {
  display: flex;
  justify-content: center;
  margin-top: 85px;
}

.social-button {
  position: relative;
  width: 48px;
  height: 48px;
  margin: 10px;
  border: 4px solid rgba(0, 0, 0, 0);
  border-radius: 48px;
  background-position: center;
  background-repeat: no-repeat;
  transition: border-color 0.15s, background-color 0.15s;
  cursor: pointer;
}

.social-button--facebook {
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.75 12.682h2.49V22.5h3.604v-9.818h3.497l.159-3.546h-3.656V6.518c0-.582.106-.99.318-1.227.212-.236.583-.355 1.112-.355h2.173l.053-3.272c-1.06-.11-1.855-.164-2.384-.164h-.636c-.566 0-1.078.09-1.537.273C10.14 2.5 9.24 3.936 9.24 6.082v3.054H6.75v3.546z' fill='white' /%3E%3C/svg%3E");
}

.social-button--twitter {
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21 6.276a7.231 7.231 0 01-2.121.596 3.778 3.778 0 001.624-2.095 7.289 7.289 0 01-2.346.919A3.645 3.645 0 0015.462 4.5c-2.384 0-4.136 2.281-3.598 4.65-3.068-.159-5.789-1.666-7.61-3.957-.968 1.702-.502 3.928 1.142 5.056a3.608 3.608 0 01-1.672-.474c-.04 1.754 1.186 3.396 2.962 3.76a3.611 3.611 0 01-1.668.065c.469 1.505 1.833 2.6 3.45 2.63A7.294 7.294 0 013 17.799 10.267 10.267 0 008.661 19.5c6.857 0 10.73-5.938 10.496-11.264A7.628 7.628 0 0021 6.276z' fill='white'/%3E%3C/svg%3E");
}

.social-button--linkedin {
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21 14.036V21h-3.858v-6.498c0-1.632-.558-2.746-1.954-2.746-1.067 0-1.7.75-1.98 1.477-.102.26-.128.62-.128.984V21H9.22s.053-11.005 0-12.145h3.86v1.721l-.026.04h.026v-.04c.512-.826 1.428-2.007 3.477-2.007 2.54 0 4.443 1.736 4.443 5.467zM5.184 3C3.864 3 3 3.906 3 5.098c0 1.166.839 2.1 2.133 2.1h.025c1.346 0 2.183-.934 2.183-2.1C7.316 3.906 6.504 3 5.184 3zM3.229 21h3.858V8.855H3.229V21z' fill='white'/%3E%3C/svg%3E");
}

.social-button--whatsapp {
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.076 14.233c-.278-.14-1.648-.813-1.903-.906-.256-.093-.441-.14-.628.14-.184.279-.719.906-.881 1.091-.162.187-.325.21-.604.07-.278-.14-1.176-.433-2.24-1.382-.828-.739-1.388-1.651-1.55-1.93-.162-.279-.017-.43.122-.569.125-.124.28-.325.418-.487.14-.163.185-.28.28-.466.092-.186.046-.348-.024-.487-.07-.14-.627-1.512-.859-2.07-.227-.542-.457-.468-.627-.478a12 12 0 00-.535-.009c-.185 0-.487.07-.742.349-.255.278-.975.952-.975 2.324 0 1.37.998 2.695 1.137 2.882.14.185 1.965 3 4.76 4.206.665.287 1.183.459 1.588.586.667.213 1.275.183 1.754.11.535-.079 1.648-.673 1.88-1.324.233-.65.233-1.208.163-1.324-.07-.117-.255-.186-.534-.326zm-5.083 6.94h-.004a9.253 9.253 0 01-4.716-1.291l-.338-.201-3.508.92.936-3.42-.22-.35A9.243 9.243 0 012.727 11.9c.001-5.11 4.159-9.267 9.27-9.267a9.2 9.2 0 016.551 2.717 9.21 9.21 0 012.713 6.557c-.003 5.11-4.16 9.266-9.268 9.266zM19.881 4.02A11.077 11.077 0 0011.993.75C5.848.75.846 5.752.843 11.899c0 1.965.513 3.883 1.49 5.573L.75 23.25l5.91-1.55a11.14 11.14 0 005.329 1.357h.004c6.145 0 11.147-5.002 11.15-11.15a11.083 11.083 0 00-3.262-7.887z' fill='white'/%3E%3C/svg%3E");
}

</style>